import TableChart from './tableChart.js';
export default TableChart;
